module.exports = __webpack_public_path__ + "img/revexpo_1375.fb0b0009.jpg";